export enum PointsArrangements
{
    Linear,
    AscendingDiagonal,
    DescendingDiagonal,
    Pattern, 
    ZigZag, 
    OnVertices,
    OnEdges,
    OnLines,
}